import { localization } from './localization'

export default () => ({
  clientDetails: {} as MazInterfaces.ClientMyProfile.ClientMyProfileDetails,
  labels: { ...localization.labels }
})
